<template>
  <div class="index-container">
    <img src="/static/images/company.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'index',
  components: {},
  data () {
    return {}
  },
  created () {},
  mounted () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.index-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("/static/images/map.png") no-repeat center;
  background-size: auto;
  img {
    width: 468px;
    height: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/welcome/index.vue